<template>
  <section class="guestbook-boxes" v-if="boxesFetched">
    <div
      class="guestbook-boxes__box-container"
      :class="{
        'box-type__voucher': box.type === 'voucher',
        'box-type__standard': box.type === 'standard',
        'box-type__info': box.type === 'info',
        'box-type__form': box.type === 'form',
        'box-type__key': box.type === 'key',
      }"
      v-for="(box, index) in guestBoxes"
      :key="index"
      v-show="isBoxVisible(box)"
    >
      <div
        class="guestbook-boxes__box-container__voucher"
        v-if="box.type === 'voucher' && isBoxVisible(box)"
      >
        <VoucherBox
          :customFonts="customFonts"
          :activeLanguage="getCookie('activeLanguage') || 'default'"
          :cookieExists="cookieExists"
          :secondLang="secondLang"
          :box="box"
        />
      </div>
      <div
        class="guestbook-boxes__box-container__standard"
        v-else-if="box.type === 'standard' && isBoxVisible(box)"
      >
        <StandardBox
          :customFonts="customFonts"
          :activeLanguage="getCookie('activeLanguage') || 'default'"
          :cookieExists="cookieExists"
          :secondLang="secondLang"
          :box="box"
        />
      </div>
      <div
        class="guestbook-boxes__box-container__info"
        v-else-if="box.type === 'info' && isBoxVisible(box)"
      >
        <InfoBox
          :customFonts="customFonts"
          :activeLanguage="getCookie('activeLanguage') || 'default'"
          :cookieExists="cookieExists"
          :secondLang="secondLang"
          :box="box"
        />
      </div>
      <div
        class="guestbook-boxes__box-container__form"
        v-else-if="box.type === 'form' && isBoxVisible(box)"
      >
        <FormBox
          :customFonts="customFonts"
          :activeLanguage="getCookie('activeLanguage') || 'default'"
          :cookieExists="cookieExists"
          :secondLang="secondLang"
          :box="box"
          :activeGuestInformation="activeGuestInformation"
        />
      </div>
      <div
        class="guestbook-boxes__box-container__key"
        v-else-if="box.type === 'key' && isBoxVisible(box)"
      >
        <KeyBox
          :customFonts="customFonts"
          :activeLanguage="getCookie('activeLanguage') || 'default'"
          :cookieExists="cookieExists"
          :secondLang="secondLang"
          :box="box"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { db } from "@/firebase";
import cookieMixin from "@/mixins/cookieMixin";
import StandardBox from "../components/BoxTypes/StandardBox";
import KeyBox from "../components/BoxTypes/KeyBox";
import FormBox from "../components/BoxTypes/FormBox";
import VoucherBox from "../components/BoxTypes/VoucherBox";
import InfoBox from "../components/BoxTypes/InfoBox";
import { trackBehavior } from "../callables";

export default {
  props: {
    customFonts: Object,
    secondLang: Boolean,
    guestPhase: String,
    cookieExists: [String],
  },
  components: {
    StandardBox,
    VoucherBox,
    InfoBox,
    FormBox,
    KeyBox,
  },
  mixins: [cookieMixin],
  data() {
    return {
      boxesFetched: false,
      activeGuestTemp: "",
    };
  },
  mounted() {
    //console.log(this.getCookie('activeLanguage'))
    this.activeGuestTemp = sessionStorage.getItem("activeGuestTemp");
    this.activeGuestTemp = this.activeGuestTemp
      ? this.activeGuestTemp
      : "unknownID";

    trackBehavior({
      action: "view",
      page: "home",
      guestID: this.activeGuestTemp,
      eventID: this.$hotelId,
      customerID: this.$customerId,
    });
  },
  firebase() {
    return {
      guestBoxes: {
        source: db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes`),
        asObject: false,
        readyCallback: function () {
          this.boxesFetched = true;
        },
      },
      activeGuestInformation: {
        source: db.ref(`activeguests/${this.$customerId}/${this.$hotelId}/${this.$route.params.guestid}`),
        asObject: true,
      },
    };
  },
  methods: {
    isBoxVisible(box) {
      return (
        !box.visibility ||
        (this.guestPhase == "anonymous" && box.visibility.anonymous) ||
        (this.guestPhase == "checkin" && box.visibility.checkin) ||
        (this.guestPhase == "precheckin" && box.visibility.precheckin)
      );
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.guestbook-boxes {
  display: grid;
  width: 100%;
  max-width: 460px;
  padding: 20px;
  margin: 0 auto;

  /* Overall grid control */
  grid-template-columns: 100%;
  grid-auto-rows: 110px;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}

.guestbook-boxes__box-container {
  max-width: 420px;
}

.box-type__standard,
.box-type__voucher,
.box-type__form,
.add-box {
  grid-row: span 2;
}

.box-type__info {
  grid-row: span 4;
}

.box-type__key {
  grid-row: span 1;
}

.guestbook-boxes__box-container__standard,
.guestbook-boxes__box-container__voucher,
.guestbook-boxes__box-container__form {
  height: 240px;
}

.guestbook-boxes__box-container__key {
  height: 110px;
}

.guestbook-boxes__box-container__info {
  height: 100%;
}

@media screen and (min-width: 700px) {
  .guestbook-boxes {
    width: 700px;
    max-width: none;

    /* When tablet size-ish, create 2 columns of 320px */
    grid-template-columns: 320px 320px;
  }
}

@media screen and (min-width: 1040px) {
  .guestbook-boxes {
    width: 1040px;

    /* When laptop size-ish, create 3 columns of 320px */
    grid-template-columns: 320px 320px 320px;
    grid-auto-rows: 240px;
  }

  .box-type__key,
  .box-type__standard,
  .box-type__voucher,
  .box-type__form,
  .add-box {
    grid-row: span 1;
  }

  .box-type__info {
    grid-row: span 2;
  }
}
</style>
